module.exports = __webpack_public_path__ + "static/media/1277_elements_category.5e90d965.png";